import styled from 'styled-components'

export const ExtraText = styled.label`
  margin-bottom: 20px;
  display: block;
`
